import React from 'react';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import './FolderIcon.scss';

export const FolderIcon = ({ folderHasContent }) => {
  const imageSrc = folderHasContent ? '/assets/folderFull.svg' : '/assets/folderEmpty.svg';

  return (
    <Svg data={imageSrc} className='folderIcon'/>
  );
};

FolderIcon.propTypes = {
  folderHasContent: PropTypes.bool,
};

